// removed by extract-text-webpack-plugin
module.exports = {"projectDelete":"_3oaolBrYdXACD6gy","title":"_1JtvxxhfjAsbb_3s","controls":"_3yQtA76gJH6I9kl0","cancel":"_2h-ofhuWiT1VIlun","delete":"_1Sn3zK81acoQSxbM"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/ProjectDelete/ProjectDelete.pcss
// module id = 494
// module chunks = 1